import { AdditiveBlending, CylinderGeometry, Mesh, Object3D, PlaneGeometry } from 'three';
import { appMixin } from '../../utils/appMixin';
import { HaloPlaneMaterial } from '../Materials/HaloPlane/material';
import { HaloCylinderMaterial } from '../Materials/HaloCylinder/material';

export class Halo extends appMixin(Object3D) {
  constructor(app) {
    super(app);

    this.plane = new Mesh(
      new PlaneGeometry(4, 4),
      new HaloPlaneMaterial({
        blending: AdditiveBlending,
        uniforms: {
          ...this.app.uniforms,
          tNoise: { value: app.tools.noise.linearTexture },
        },
      })
    );
    this.plane.rotation.x = -Math.PI * 0.5;
    this.plane.position.y = 0.01;

    this.cylinder = new Mesh(
      new CylinderGeometry(1, 1, 3, 16, 1, true),
      new HaloCylinderMaterial({
        blending: AdditiveBlending,
        side: 2,
        // depthTest: false,
        // depthWrite: false,
        transparent: true,
        uniforms: {
          ...this.app.uniforms,
          tNoise: { value: app.tools.noise.linearTexture },
        },
      })
    );
    this.cylinder.rotation.y = Math.PI;
    this.add(this.cylinder);
  }
}
